"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ColorField_1 = __importDefault(require("../Field/ColorField/ColorField"));
var OpacityField_1 = __importDefault(require("../Field/OpacityField/OpacityField"));
var WidthField_1 = __importDefault(require("../Field/WidthField/WidthField"));
var _cloneDeep = require('lodash/cloneDeep');
var _isEqual = require('lodash/isEqual');
var FontPicker_1 = __importDefault(require("../Field/FontPicker/FontPicker"));
var OffsetField_1 = __importDefault(require("../Field/OffsetField/OffsetField"));
var AttributeCombo_1 = __importDefault(require("../../Filter/AttributeCombo/AttributeCombo"));
require("./PropTextEditor.css");
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var RotateField_1 = __importDefault(require("../Field/RotateField/RotateField"));
var en_US_1 = __importDefault(require("../../../locale/en_US"));
/**
 * The PropTextEditor class. Allows to edit text styles solely based on a
 * feature property. The entered word will be understood as the property name
 * of a feature. No static text is allowed.
 */
var PropTextEditor = /** @class */ (function (_super) {
    __extends(PropTextEditor, _super);
    function PropTextEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formatLabel = function (label) {
            var prefix = '\\{\\{';
            var suffix = '\\}\\}';
            var regExp = new RegExp(prefix + '.*' + suffix, 'g');
            return label.replace(regExp, function (match) { return match.slice(2, match.length - 2); });
        };
        _this.onLabelChange = function (newAttrName) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            // add the removed curly braces to newAttrName
            // so it will be recognized as a placeholder for a featureProp
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.label = "{{" + newAttrName + "}}";
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onColorChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.color = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onFontChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.font = value.length > 0 ? value : undefined;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onOpacityChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.opacity = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onSizeChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.size = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onOffsetXChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            var newOffset = [value, (symbolizer.offset ? symbolizer.offset[1] : 0)];
            symbolizer.offset = newOffset;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onOffsetYChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            var newOffset = [(symbolizer.offset ? symbolizer.offset[0] : 0), value];
            symbolizer.offset = newOffset;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onRotateChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.rotate = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onHaloColorChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.haloColor = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        _this.onHaloWidthChange = function (value) {
            var onSymbolizerChange = _this.props.onSymbolizerChange;
            var symbolizer = _cloneDeep(_this.props.symbolizer);
            symbolizer.haloWidth = value;
            if (onSymbolizerChange) {
                onSymbolizerChange(symbolizer);
            }
        };
        return _this;
    }
    PropTextEditor.prototype.shouldComponentUpdate = function (nextProps) {
        var diffProps = !_isEqual(this.props, nextProps);
        return diffProps;
    };
    PropTextEditor.prototype.render = function () {
        var _a = this.props, internalDataDef = _a.internalDataDef, locale = _a.locale;
        var symbolizer = _cloneDeep(this.props.symbolizer);
        var opacity = symbolizer.opacity, color = symbolizer.color, font = symbolizer.font, offset = symbolizer.offset, size = symbolizer.size, rotate = symbolizer.rotate, haloColor = symbolizer.haloColor, haloWidth = symbolizer.haloWidth;
        // split the current offset
        var offsetX;
        var offsetY;
        if (offset) {
            offsetX = offset[0];
            offsetY = offset[1];
        }
        return (React.createElement("div", { className: "gs-text-symbolizer-prop-editor" },
            React.createElement("div", { className: "editor-field attribute-field" },
                React.createElement("span", { className: "label" },
                    locale.propFieldLabel,
                    ":"),
                React.createElement(AttributeCombo_1.default, { value: symbolizer.label ? this.formatLabel(symbolizer.label) : undefined, placeholder: locale.attributeComboPlaceholder, internalDataDef: internalDataDef, onAttributeChange: this.onLabelChange })),
            locale.colorLabel,
            React.createElement(ColorField_1.default, { color: color, onChange: this.onColorChange }),
            locale.fontLabel,
            React.createElement(FontPicker_1.default, { font: font, onChange: this.onFontChange }),
            locale.opacityLabel,
            React.createElement(OpacityField_1.default, { opacity: opacity, onChange: this.onOpacityChange }),
            locale.sizeLabel,
            React.createElement(WidthField_1.default, { width: size, onChange: this.onSizeChange }),
            locale.offsetXLabel,
            React.createElement(OffsetField_1.default, { offset: offsetX, onChange: this.onOffsetXChange }),
            locale.offsetYLabel,
            React.createElement(OffsetField_1.default, { offset: offsetY, onChange: this.onOffsetYChange }),
            locale.rotateLabel,
            React.createElement(RotateField_1.default, { rotate: rotate, onChange: this.onRotateChange }),
            locale.haloColorLabel,
            React.createElement(ColorField_1.default, { color: haloColor, onChange: this.onHaloColorChange }),
            locale.haloWidthLabel,
            React.createElement(WidthField_1.default, { width: haloWidth, onChange: this.onHaloWidthChange })));
    };
    PropTextEditor.defaultProps = {
        locale: en_US_1.default.GsPropTextEditor
    };
    PropTextEditor.componentName = 'PropTextEditor';
    return PropTextEditor;
}(React.Component));
exports.PropTextEditor = PropTextEditor;
exports.default = LocaleWrapper_1.localize(PropTextEditor, PropTextEditor.componentName);
//# sourceMappingURL=PropTextEditor.js.map